<img
  class="watermarkImg"
  src="./assets/images/psh-watermark.png"
  alt="watermark"
/>

<section class="sponsorChildProfile dsktpOnly">
  <div class="container">
    <div class="breadcrum dark">
      <div class="crumbs">
        <div class="BreadcrumbList">
          <p><a href="javascript:;" routerLink="/">Home</a></p>
          <span> &gt; </span>
          <p>
            <a href="javascript:;" routerLink="/sponsorship-program"
              >Sponsorship Program</a
            >
          </p>
          <span> &gt; </span>
          <p>
            <a href="javascript:;" routerLink="/orphan-profiles"
              >All Profiles</a
            >
          </p>
          <span> &gt; </span>
          <p *ngIf="orphan">{{ orphan.name }}</p>
        </div>
      </div>
    </div>
    <div class="profileWrapper">
      <div class="profileLeft">
        <div class="stickyCard">
          <div class="singleOrphan" *ngIf="orphan">
            <div class="single_img">
              <canvas class="galleryCanvas"></canvas>
              <img
                class="galleryImg"
                [src]="orphan.child_picture"
                [alt]="orphan.name + 'img'"
              />
            </div>
            <div class="orphanInformation">
              <p class="orphanName">{{ orphan.name }}</p>
              <div class="orphanAllDetails">
                <p class="orphanInfo">
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="13"
                      cy="13"
                      r="13"
                      fill="url(#paint0_linear_3394_2429)"
                    />
                    <g clip-path="url(#clip0_3394_2429)">
                      <path
                        d="M19.886 15.8674V13.8009C19.8854 13.1671 19.3718 12.6535 18.738 12.6529H17.8196V10.3568C17.8196 10.23 17.7168 10.1272 17.59 10.1272H16.2123C16.0855 10.1272 15.9827 10.23 15.9827 10.3568V12.6529H13.9162V9.89758C13.9162 9.77078 13.8134 9.66797 13.6866 9.66797H12.309C12.1822 9.66797 12.0794 9.77078 12.0794 9.89758V12.6529H10.0129V10.3568C10.0129 10.23 9.91007 10.1272 9.78327 10.1272H8.40563C8.27883 10.1272 8.17602 10.23 8.17602 10.3568V12.6529H7.25759C6.62392 12.6535 6.11033 13.1671 6.10954 13.8009V15.8674C6.1017 16.3601 6.36673 16.817 6.79837 17.0549V19.5411H6.33915C6.21235 19.5411 6.10954 19.6439 6.10954 19.7707C6.10954 19.8975 6.21235 20.0003 6.33915 20.0003H19.6564C19.7832 20.0003 19.886 19.8975 19.886 19.7707C19.886 19.6439 19.7832 19.5411 19.6564 19.5411H19.1972V17.0584C19.6222 16.8119 19.8845 16.3586 19.886 15.8674ZM16.4419 10.5864H17.3603V12.6529H16.4419V10.5864ZM12.5386 10.1272H13.457V12.6529H12.5386V10.1272ZM8.63523 10.5864H9.55367V12.6529H8.63523V10.5864ZM6.56876 13.8009C6.56876 13.4204 6.87718 13.1121 7.25759 13.1121H18.738C19.1185 13.1121 19.4268 13.4204 19.4268 13.8009V15.8674C19.426 16.2321 19.2108 16.5622 18.8773 16.71C18.5302 16.8562 18.1293 16.781 17.8589 16.5188C17.6865 16.3458 17.5898 16.1115 17.59 15.8674V14.949C17.5888 14.6022 17.3921 14.2859 17.0816 14.1315L17.0676 14.1239C17.0308 14.1065 16.9929 14.0917 16.9542 14.0796C16.9313 14.072 16.9103 14.0645 16.8876 14.059C16.8582 14.0523 16.8285 14.047 16.7985 14.0433C16.7784 14.0404 16.7591 14.0343 16.7386 14.0328C16.7276 14.0328 16.717 14.0343 16.7063 14.0339C16.6954 14.0334 16.6835 14.0305 16.6715 14.0305C16.6461 14.0305 16.6215 14.0358 16.5963 14.0378C16.571 14.0399 16.5442 14.0411 16.5184 14.0454C16.4787 14.0528 16.4394 14.0629 16.4011 14.0755C16.3804 14.0819 16.3593 14.0865 16.3391 14.0943C16.2963 14.1117 16.2549 14.1324 16.2153 14.1563C16.2009 14.1646 16.1855 14.1706 16.1713 14.1793C16.1177 14.2141 16.0678 14.2543 16.0225 14.2994C15.8495 14.4711 15.7525 14.7051 15.7531 14.949V15.4082C15.7531 15.9154 15.342 16.3266 14.8347 16.3266C14.3275 16.3266 13.9162 15.9154 13.9162 15.4082V14.949C13.9151 14.6022 13.7183 14.2859 13.4079 14.1315L13.3939 14.1239C13.3571 14.1065 13.3192 14.0917 13.2804 14.0796C13.2576 14.072 13.2366 14.0645 13.2138 14.059C13.1845 14.0523 13.1547 14.047 13.1248 14.0433C13.1046 14.0404 13.0853 14.0343 13.0648 14.0328C13.0538 14.0328 13.0433 14.0343 13.0325 14.0339C13.0217 14.0334 13.0098 14.0305 12.9978 14.0305C12.9723 14.0305 12.9478 14.0358 12.9226 14.0378C12.8972 14.0399 12.8704 14.0411 12.8446 14.0454C12.8051 14.0528 12.7659 14.0629 12.7276 14.0755C12.7066 14.0819 12.6856 14.0865 12.6654 14.0943C12.6228 14.1117 12.5815 14.1323 12.542 14.1561C12.5274 14.1644 12.5118 14.1706 12.4975 14.1791C12.4439 14.2137 12.3941 14.2539 12.3488 14.2989C12.1757 14.4708 12.0787 14.705 12.0794 14.949V16.3266C12.0794 16.8338 11.6682 17.245 11.1609 17.245C10.6537 17.245 10.2425 16.8338 10.2425 16.3266V14.949C10.2414 14.6022 10.0446 14.2859 9.73417 14.1315L9.72015 14.1239C9.68338 14.1065 9.64549 14.0917 9.6067 14.0796C9.58382 14.072 9.56286 14.0645 9.5401 14.059C9.51073 14.0523 9.48102 14.047 9.45108 14.0433C9.4309 14.0404 9.41162 14.0343 9.3911 14.0328C9.3707 14.0312 9.34704 14.0305 9.32406 14.0305C8.81686 14.0305 8.40563 14.4416 8.40563 14.949V15.8674C8.40596 16.1107 8.30999 16.3442 8.13857 16.5169C7.91098 16.7359 7.58933 16.8272 7.28057 16.7603C7.22563 16.7486 7.17182 16.732 7.11991 16.7105C7.01497 16.6642 6.91934 16.5993 6.83772 16.5188C6.66529 16.3458 6.56865 16.1115 6.56876 15.8674V13.8009ZM7.25759 19.5411V17.226C7.28057 17.2298 7.30355 17.2308 7.32653 17.2335L7.34414 17.2354C7.54504 17.2561 7.74808 17.2326 7.9389 17.1664C7.9972 17.1459 8.05415 17.1215 8.1092 17.0935C8.12097 17.0877 8.13218 17.0815 8.1444 17.0751C8.18891 17.0509 8.23219 17.0243 8.27389 16.9954C8.28723 16.9863 8.30069 16.9778 8.31381 16.9681C8.66528 16.7124 8.87067 16.3019 8.86484 15.8674V14.949C8.86462 14.8271 8.91316 14.7103 8.9996 14.6245C9.02259 14.6017 9.04781 14.5813 9.07494 14.5638C9.07976 14.5609 9.08503 14.5588 9.08985 14.5561C9.11239 14.5423 9.13593 14.5305 9.16037 14.5209C9.16755 14.5182 9.17484 14.5165 9.18201 14.5143C9.20443 14.5067 9.22742 14.501 9.25085 14.497C9.26184 14.4952 9.27383 14.4948 9.28459 14.4936C9.30388 14.4918 9.32327 14.4911 9.34267 14.4915C9.35713 14.4922 9.37159 14.4937 9.38583 14.4959C9.4031 14.4979 9.42025 14.5011 9.43707 14.5053C9.44279 14.5067 9.44806 14.5088 9.45355 14.5104C9.65367 14.5834 9.78585 14.7747 9.78327 14.9877V16.3266C9.78327 17.0874 10.4001 17.7043 11.1609 17.7043C11.9218 17.7043 12.5386 17.0874 12.5386 16.3266V14.949C12.5386 14.793 12.6179 14.6478 12.7491 14.5636C12.753 14.5612 12.7576 14.5595 12.7616 14.557C12.7849 14.5428 12.8093 14.5305 12.8348 14.5207C12.8413 14.5182 12.8479 14.5168 12.8543 14.5147C12.8768 14.5071 12.8998 14.5011 12.9232 14.4968C12.9342 14.4952 12.9462 14.4946 12.9563 14.4936C12.9756 14.4916 12.9951 14.491 13.0146 14.4915C13.0291 14.4922 13.0434 14.4937 13.0578 14.4959C13.075 14.4979 13.0921 14.5011 13.109 14.5053C13.1147 14.5067 13.12 14.5088 13.1255 14.5104C13.3263 14.5828 13.4594 14.7743 13.457 14.9877V15.4082C13.457 16.169 14.0739 16.7858 14.8347 16.7858C15.5956 16.7858 16.2123 16.169 16.2123 15.4082V14.949C16.2121 14.8271 16.2606 14.7103 16.3471 14.6245C16.37 14.6017 16.3953 14.5813 16.4224 14.5638C16.4272 14.5609 16.4325 14.5588 16.4375 14.5558C16.46 14.5422 16.4835 14.5305 16.5078 14.5209C16.515 14.5182 16.5225 14.5165 16.5308 14.5143C16.5529 14.5067 16.5756 14.501 16.5985 14.497C16.6095 14.4952 16.6215 14.4948 16.6323 14.4936C16.6516 14.4918 16.671 14.4911 16.6904 14.4915C16.7048 14.4922 16.7193 14.4937 16.7335 14.4959C16.7508 14.4979 16.7679 14.5011 16.7848 14.5053C16.7905 14.5067 16.7957 14.5088 16.8012 14.5104C17.0012 14.5835 17.1334 14.7748 17.1307 14.9877V15.8674C17.1304 16.2333 17.2755 16.5845 17.5342 16.8434C17.5797 16.8878 17.6283 16.9291 17.6795 16.967C17.6944 16.9778 17.7098 16.9874 17.7255 16.9977C17.7641 17.0241 17.8031 17.0485 17.8437 17.0707C17.8598 17.0794 17.8758 17.088 17.8921 17.0959C17.9384 17.1189 17.9858 17.1393 18.0343 17.157C18.0439 17.1605 18.0533 17.1649 18.0632 17.1681C18.1892 17.2111 18.3206 17.2358 18.4536 17.2416H18.4551C18.5191 17.2441 18.5833 17.2422 18.6471 17.2358L18.6701 17.2333C18.693 17.2308 18.716 17.2298 18.739 17.226V19.5411H7.25759Z"
                        fill="#221F1F"
                      />
                      <path
                        d="M12.9957 9.20846C13.6295 9.20768 14.1431 8.69408 14.1437 8.06042C14.1437 7.50927 13.3449 6.32479 13.1847 6.09305C13.1395 6.03442 13.0698 6 12.9957 6C12.9217 6 12.8519 6.03442 12.8068 6.09305C12.6465 6.32479 11.8477 7.50927 11.8477 8.06042C11.8484 8.69408 12.362 9.20768 12.9957 9.20846ZM12.9957 6.6386C13.3261 7.15499 13.6845 7.80962 13.6845 8.06042C13.6845 8.44082 13.3762 8.74924 12.9957 8.74924C12.6153 8.74924 12.3069 8.44082 12.3069 8.06042C12.3069 7.80962 12.6653 7.15499 12.9957 6.6386Z"
                        fill="#00AAE9"
                      />
                      <path
                        d="M16.9019 9.66744C17.5357 9.66666 18.0493 9.15307 18.05 8.5194C18.05 7.96825 17.2512 6.78378 17.091 6.55204C17.0458 6.4934 16.9761 6.45898 16.9019 6.45898C16.828 6.45898 16.7581 6.4934 16.713 6.55204C16.5527 6.78378 15.7539 7.96825 15.7539 8.5194C15.7547 9.15307 16.2683 9.66666 16.9019 9.66744ZM16.9019 7.09758C17.2323 7.61398 17.5908 8.26861 17.5908 8.5194C17.5908 8.8998 17.2825 9.20823 16.9019 9.20823C16.5215 9.20823 16.2131 8.8998 16.2131 8.5194C16.2131 8.26861 16.5715 7.61398 16.9019 7.09758Z"
                        fill="#00AAE9"
                      />
                      <path
                        d="M9.09335 9.66744C9.72713 9.66666 10.2407 9.15307 10.2414 8.5194C10.2414 7.96825 9.44259 6.78378 9.28238 6.55204C9.23719 6.4934 9.16746 6.45898 9.09335 6.45898C9.01936 6.45898 8.94951 6.4934 8.90444 6.55204C8.74412 6.78378 7.94531 7.96825 7.94531 8.5194C7.9461 9.15307 8.45969 9.66666 9.09335 9.66744ZM9.09335 7.09758C9.42375 7.61398 9.78218 8.26861 9.78218 8.5194C9.78218 8.8998 9.47387 9.20823 9.09335 9.20823C8.71295 9.20823 8.40453 8.8998 8.40453 8.5194C8.40453 8.26861 8.76296 7.61398 9.09335 7.09758Z"
                        fill="#00AAE9"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_3394_2429"
                        x1="13"
                        y1="0"
                        x2="13"
                        y2="26"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#F5F6FD" />
                        <stop offset="1" stop-color="#F1F8FF" />
                      </linearGradient>
                      <clipPath id="clip0_3394_2429">
                        <rect
                          width="14"
                          height="14"
                          fill="white"
                          transform="translate(6 6)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <span>{{ orphan.dob | dobToAge }}</span>
                </p>
                <p class="orphanInfo">
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="13"
                      cy="13"
                      r="13"
                      fill="url(#paint0_linear_3394_2438)"
                    />
                    <g clip-path="url(#clip0_3394_2438)">
                      <path
                        d="M13 6C9.14027 6 6 9.14027 6 13C6 16.8597 9.14027 20 13 20C16.8597 20 20 16.8597 20 13C20 9.14027 16.8597 6 13 6ZM13 19.125C9.62262 19.125 6.875 16.3774 6.875 13C6.875 9.62262 9.62262 6.875 13 6.875C16.3774 6.875 19.125 9.62262 19.125 13C19.125 16.3774 16.3774 19.125 13 19.125Z"
                        fill="#221F1F"
                        stroke="#F4F6FD"
                        stroke-width="0.3"
                      />
                      <path
                        d="M13.4375 8.625H12.5625V13.1811L15.3157 15.9343L15.9343 15.3157L13.4375 12.8188V8.625Z"
                        fill="#00AAE9"
                        stroke="#F4F6FD"
                        stroke-width="0.2"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_3394_2438"
                        x1="13"
                        y1="0"
                        x2="13"
                        y2="26"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#F5F6FD" />
                        <stop offset="1" stop-color="#F1F8FF" />
                      </linearGradient>
                      <clipPath id="clip0_3394_2438">
                        <rect
                          width="14"
                          height="14"
                          fill="white"
                          transform="translate(6 6)"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <span>{{
                    lastSponsoredDate(orphan.sponserd_date, orphan.is_sponsered)
                  }}</span>
                </p>
                <p class="orphanInfo">{{ orphan.one_line_intro }}</p>
              </div>
            </div>
            <div class="childCardBtnsWrapper">
              <a
                href="javascript:;"
                *ngIf="!disabledBtn"
                class="sponsorMainBtn"
                (click)="saveOrphan(orphan, moreChildren)"
              >
                Sponsor {{ orphan.name | shortName }}
              </a>
              <a
                href="javascript:;"
                *ngIf="disabledBtn"
                class="sponsorMainBtn loaderBlue"
              >
                <img
                  class="loadingImg"
                  src="/assets/new-images/pshLoaderWhite.webp"
                  alt="loading"
                />
              </a>
              <!-- <div class="loader" *ngIf="disabledBtn">
                <img class="loadingImg" src="/assets/new-images/pshLoader.webp" alt="loading">
              </div> -->
              <a href="javascript:;" class="copyMainBtn" (click)="copyUrl()">
                <svg
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.0236 10.6942C12.8396 10.6942 12.6556 10.6242 12.5154 10.4836C11.3945 9.36275 9.57072 9.36239 8.44947 10.4836C8.16916 10.7643 7.71347 10.7643 7.43316 10.4836C7.15249 10.203 7.15249 9.748 7.43316 9.46733C9.11468 7.78545 11.8506 7.78581 13.5318 9.46733C13.8124 9.748 13.8124 10.203 13.5318 10.4836C13.3916 10.6242 13.2072 10.6942 13.0236 10.6942Z"
                    fill="#A6BCC8"
                    stroke="#A6BCC8"
                    stroke-width="0.5"
                  />
                  <path
                    d="M12.5176 14.7945C11.4133 14.7945 10.3089 14.374 9.46832 13.5335C9.18764 13.2528 9.18764 12.7978 9.46832 12.5171C9.74863 12.2365 10.2043 12.2365 10.4846 12.5171C11.6055 13.638 13.4293 13.6384 14.5506 12.5171C14.8309 12.2365 15.2866 12.2365 15.5669 12.5171C15.8476 12.7978 15.8476 13.2528 15.5669 13.5335C14.726 14.374 13.6216 14.7945 12.5176 14.7945Z"
                    fill="#A6BCC8"
                    stroke="#A6BCC8"
                    stroke-width="0.5"
                  />
                  <path
                    d="M15.0585 13.7434C14.8745 13.7434 14.6905 13.6733 14.5503 13.5328C14.2697 13.2521 14.2697 12.7971 14.5503 12.5165L18.5653 8.50152C18.8456 8.22085 19.3013 8.22085 19.5816 8.50152C19.8623 8.78219 19.8623 9.23716 19.5816 9.51783L15.5667 13.5328C15.4265 13.6733 15.2425 13.7434 15.0585 13.7434Z"
                    fill="#A6BCC8"
                    stroke="#A6BCC8"
                    stroke-width="0.5"
                  />
                  <path
                    d="M9.01163 19.7911C8.82763 19.7911 8.64363 19.721 8.50347 19.5805C8.2228 19.2998 8.2228 18.8448 8.50347 18.5642L10.7478 16.3199C11.0281 16.0392 11.4838 16.0392 11.7641 16.3199C12.0448 16.6006 12.0448 17.0555 11.7641 17.3362L9.51979 19.5805C9.37963 19.721 9.19563 19.7911 9.01163 19.7911Z"
                    fill="#A6BCC8"
                    stroke="#A6BCC8"
                    stroke-width="0.5"
                  />
                  <path
                    d="M3.9296 14.7088C3.7456 14.7088 3.5616 14.6387 3.42144 14.4982C3.14077 14.2176 3.14077 13.7626 3.42144 13.4819L7.43638 9.46734C7.71705 9.18667 8.17238 9.18667 8.45269 9.46734C8.73336 9.74801 8.73336 10.203 8.45269 10.4837L4.43775 14.4982C4.29724 14.6384 4.11324 14.7088 3.9296 14.7088Z"
                    fill="#A6BCC8"
                    stroke="#A6BCC8"
                    stroke-width="0.5"
                  />
                  <path
                    d="M11.746 6.89105C11.562 6.89105 11.3784 6.82097 11.2378 6.68082C10.9572 6.40014 10.9572 5.94518 11.2378 5.66414L13.4821 3.41949C13.7628 3.13882 14.2178 3.13882 14.4988 3.41949C14.7795 3.70016 14.7795 4.15513 14.4988 4.43616L12.2545 6.68082C12.114 6.82061 11.9296 6.89105 11.746 6.89105Z"
                    fill="#A6BCC8"
                    stroke="#A6BCC8"
                    stroke-width="0.5"
                  />
                  <path
                    d="M6.46883 20.8208C5.35728 20.8208 4.24573 20.4075 3.41953 19.5809C1.76641 17.9278 1.76641 15.1351 3.41953 13.482C3.69984 13.2013 4.15553 13.2013 4.43584 13.482C4.71652 13.7627 4.71652 14.2176 4.43584 14.4983C3.334 15.6001 3.334 17.4624 4.43584 18.5643C5.53769 19.6661 7.39997 19.6661 8.50181 18.5643C8.78212 18.2836 9.23781 18.2836 9.51813 18.5643C9.7988 18.8449 9.7988 19.2999 9.51813 19.5806C8.69192 20.4075 7.58038 20.8208 6.46883 20.8208Z"
                    fill="#A6BCC8"
                    stroke="#A6BCC8"
                    stroke-width="0.5"
                  />
                  <path
                    d="M19.0744 9.72872C18.8904 9.72872 18.7064 9.65864 18.5662 9.51812C18.2856 9.23745 18.2856 8.78248 18.5662 8.50181C19.6681 7.39997 19.6681 5.53769 18.5662 4.43584C17.4644 3.334 15.6021 3.334 14.5003 4.43584C14.2199 4.71652 13.7643 4.71652 13.4839 4.43584C13.2033 4.15517 13.2033 3.7002 13.4839 3.41953C15.1371 1.76641 17.9298 1.76641 19.5829 3.41953C21.236 5.07266 21.236 7.86536 19.5829 9.51848C19.4424 9.65864 19.2584 9.72872 19.0744 9.72872Z"
                    fill="#A6BCC8"
                    stroke="#A6BCC8"
                    stroke-width="0.5"
                  />
                </svg>
                <p class="copyToolTip">Copy Link</p>
              </a>
            </div>
          </div>
          <ng-container *ngIf="loading">
            <div class="singleOrphan skeleton"></div>
          </ng-container>
        </div>
      </div>
      <div class="profileRight">
        <div class="dividerTop">
          <div class="videoWrapper" [ngClass]="loading ? 'skeleton' : ''">
            <iframe
              *ngIf="orphan"
              width="420"
              height="345"
              [src]="orphanVideoUrl"
              frameborder="0"
            ></iframe>
          </div>
          <div class="orphanInformationRight" *ngIf="orphan">
            <div class="orphanParas">
              <h2>{{ orphan.name }}’s Story</h2>
              <div class="parasWrapper">
                <p *ngFor="let para of orphanStory">{{ para }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="dividerTop bottom" *ngIf="orphan && !isMobile">
          <app-sponsor-faqs [orphanType]="orphanType"></app-sponsor-faqs>
        </div>
      </div>
    </div>
  </div>
  <app-more-children
    *ngIf="moreChildren && !isMobile"
    [moreChildren]="moreChildren"
    [appClass]="''"
  >
  </app-more-children>
</section>

<section class="sponsorChildProfile mobOnly">
  <div class="container">
    <div class="breadcrum dark">
      <div class="crumbs">
        <div class="BreadcrumbList">
          <p><a href="javascript:;" routerLink="/">Home</a></p>
          <span> &gt; </span>
          <p>
            <a href="javascript:;" routerLink="/sponsorship-program"
              >Sponsorship Program</a
            >
          </p>
          <span> &gt; </span>
          <p>
            <a href="javascript:;" routerLink="/orphan-profiles"
              >All Profiles</a
            >
          </p>
          <span> &gt; </span>
          <p *ngIf="orphan">{{ orphan.name }}</p>
        </div>
      </div>
    </div>
    <div class="orphanInformation" [ngClass]="loading ? 'skeleton' : ''">
      <ng-container *ngIf="orphan">
        <p class="orphanName">{{ orphan.name }}</p>
        <div class="orphanAllDetails">
          <p class="orphanInfo">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="13"
                cy="13"
                r="13"
                fill="url(#paint0_linear_3394_2429)"
              />
              <g clip-path="url(#clip0_3394_2429)">
                <path
                  d="M19.886 15.8674V13.8009C19.8854 13.1671 19.3718 12.6535 18.738 12.6529H17.8196V10.3568C17.8196 10.23 17.7168 10.1272 17.59 10.1272H16.2123C16.0855 10.1272 15.9827 10.23 15.9827 10.3568V12.6529H13.9162V9.89758C13.9162 9.77078 13.8134 9.66797 13.6866 9.66797H12.309C12.1822 9.66797 12.0794 9.77078 12.0794 9.89758V12.6529H10.0129V10.3568C10.0129 10.23 9.91007 10.1272 9.78327 10.1272H8.40563C8.27883 10.1272 8.17602 10.23 8.17602 10.3568V12.6529H7.25759C6.62392 12.6535 6.11033 13.1671 6.10954 13.8009V15.8674C6.1017 16.3601 6.36673 16.817 6.79837 17.0549V19.5411H6.33915C6.21235 19.5411 6.10954 19.6439 6.10954 19.7707C6.10954 19.8975 6.21235 20.0003 6.33915 20.0003H19.6564C19.7832 20.0003 19.886 19.8975 19.886 19.7707C19.886 19.6439 19.7832 19.5411 19.6564 19.5411H19.1972V17.0584C19.6222 16.8119 19.8845 16.3586 19.886 15.8674ZM16.4419 10.5864H17.3603V12.6529H16.4419V10.5864ZM12.5386 10.1272H13.457V12.6529H12.5386V10.1272ZM8.63523 10.5864H9.55367V12.6529H8.63523V10.5864ZM6.56876 13.8009C6.56876 13.4204 6.87718 13.1121 7.25759 13.1121H18.738C19.1185 13.1121 19.4268 13.4204 19.4268 13.8009V15.8674C19.426 16.2321 19.2108 16.5622 18.8773 16.71C18.5302 16.8562 18.1293 16.781 17.8589 16.5188C17.6865 16.3458 17.5898 16.1115 17.59 15.8674V14.949C17.5888 14.6022 17.3921 14.2859 17.0816 14.1315L17.0676 14.1239C17.0308 14.1065 16.9929 14.0917 16.9542 14.0796C16.9313 14.072 16.9103 14.0645 16.8876 14.059C16.8582 14.0523 16.8285 14.047 16.7985 14.0433C16.7784 14.0404 16.7591 14.0343 16.7386 14.0328C16.7276 14.0328 16.717 14.0343 16.7063 14.0339C16.6954 14.0334 16.6835 14.0305 16.6715 14.0305C16.6461 14.0305 16.6215 14.0358 16.5963 14.0378C16.571 14.0399 16.5442 14.0411 16.5184 14.0454C16.4787 14.0528 16.4394 14.0629 16.4011 14.0755C16.3804 14.0819 16.3593 14.0865 16.3391 14.0943C16.2963 14.1117 16.2549 14.1324 16.2153 14.1563C16.2009 14.1646 16.1855 14.1706 16.1713 14.1793C16.1177 14.2141 16.0678 14.2543 16.0225 14.2994C15.8495 14.4711 15.7525 14.7051 15.7531 14.949V15.4082C15.7531 15.9154 15.342 16.3266 14.8347 16.3266C14.3275 16.3266 13.9162 15.9154 13.9162 15.4082V14.949C13.9151 14.6022 13.7183 14.2859 13.4079 14.1315L13.3939 14.1239C13.3571 14.1065 13.3192 14.0917 13.2804 14.0796C13.2576 14.072 13.2366 14.0645 13.2138 14.059C13.1845 14.0523 13.1547 14.047 13.1248 14.0433C13.1046 14.0404 13.0853 14.0343 13.0648 14.0328C13.0538 14.0328 13.0433 14.0343 13.0325 14.0339C13.0217 14.0334 13.0098 14.0305 12.9978 14.0305C12.9723 14.0305 12.9478 14.0358 12.9226 14.0378C12.8972 14.0399 12.8704 14.0411 12.8446 14.0454C12.8051 14.0528 12.7659 14.0629 12.7276 14.0755C12.7066 14.0819 12.6856 14.0865 12.6654 14.0943C12.6228 14.1117 12.5815 14.1323 12.542 14.1561C12.5274 14.1644 12.5118 14.1706 12.4975 14.1791C12.4439 14.2137 12.3941 14.2539 12.3488 14.2989C12.1757 14.4708 12.0787 14.705 12.0794 14.949V16.3266C12.0794 16.8338 11.6682 17.245 11.1609 17.245C10.6537 17.245 10.2425 16.8338 10.2425 16.3266V14.949C10.2414 14.6022 10.0446 14.2859 9.73417 14.1315L9.72015 14.1239C9.68338 14.1065 9.64549 14.0917 9.6067 14.0796C9.58382 14.072 9.56286 14.0645 9.5401 14.059C9.51073 14.0523 9.48102 14.047 9.45108 14.0433C9.4309 14.0404 9.41162 14.0343 9.3911 14.0328C9.3707 14.0312 9.34704 14.0305 9.32406 14.0305C8.81686 14.0305 8.40563 14.4416 8.40563 14.949V15.8674C8.40596 16.1107 8.30999 16.3442 8.13857 16.5169C7.91098 16.7359 7.58933 16.8272 7.28057 16.7603C7.22563 16.7486 7.17182 16.732 7.11991 16.7105C7.01497 16.6642 6.91934 16.5993 6.83772 16.5188C6.66529 16.3458 6.56865 16.1115 6.56876 15.8674V13.8009ZM7.25759 19.5411V17.226C7.28057 17.2298 7.30355 17.2308 7.32653 17.2335L7.34414 17.2354C7.54504 17.2561 7.74808 17.2326 7.9389 17.1664C7.9972 17.1459 8.05415 17.1215 8.1092 17.0935C8.12097 17.0877 8.13218 17.0815 8.1444 17.0751C8.18891 17.0509 8.23219 17.0243 8.27389 16.9954C8.28723 16.9863 8.30069 16.9778 8.31381 16.9681C8.66528 16.7124 8.87067 16.3019 8.86484 15.8674V14.949C8.86462 14.8271 8.91316 14.7103 8.9996 14.6245C9.02259 14.6017 9.04781 14.5813 9.07494 14.5638C9.07976 14.5609 9.08503 14.5588 9.08985 14.5561C9.11239 14.5423 9.13593 14.5305 9.16037 14.5209C9.16755 14.5182 9.17484 14.5165 9.18201 14.5143C9.20443 14.5067 9.22742 14.501 9.25085 14.497C9.26184 14.4952 9.27383 14.4948 9.28459 14.4936C9.30388 14.4918 9.32327 14.4911 9.34267 14.4915C9.35713 14.4922 9.37159 14.4937 9.38583 14.4959C9.4031 14.4979 9.42025 14.5011 9.43707 14.5053C9.44279 14.5067 9.44806 14.5088 9.45355 14.5104C9.65367 14.5834 9.78585 14.7747 9.78327 14.9877V16.3266C9.78327 17.0874 10.4001 17.7043 11.1609 17.7043C11.9218 17.7043 12.5386 17.0874 12.5386 16.3266V14.949C12.5386 14.793 12.6179 14.6478 12.7491 14.5636C12.753 14.5612 12.7576 14.5595 12.7616 14.557C12.7849 14.5428 12.8093 14.5305 12.8348 14.5207C12.8413 14.5182 12.8479 14.5168 12.8543 14.5147C12.8768 14.5071 12.8998 14.5011 12.9232 14.4968C12.9342 14.4952 12.9462 14.4946 12.9563 14.4936C12.9756 14.4916 12.9951 14.491 13.0146 14.4915C13.0291 14.4922 13.0434 14.4937 13.0578 14.4959C13.075 14.4979 13.0921 14.5011 13.109 14.5053C13.1147 14.5067 13.12 14.5088 13.1255 14.5104C13.3263 14.5828 13.4594 14.7743 13.457 14.9877V15.4082C13.457 16.169 14.0739 16.7858 14.8347 16.7858C15.5956 16.7858 16.2123 16.169 16.2123 15.4082V14.949C16.2121 14.8271 16.2606 14.7103 16.3471 14.6245C16.37 14.6017 16.3953 14.5813 16.4224 14.5638C16.4272 14.5609 16.4325 14.5588 16.4375 14.5558C16.46 14.5422 16.4835 14.5305 16.5078 14.5209C16.515 14.5182 16.5225 14.5165 16.5308 14.5143C16.5529 14.5067 16.5756 14.501 16.5985 14.497C16.6095 14.4952 16.6215 14.4948 16.6323 14.4936C16.6516 14.4918 16.671 14.4911 16.6904 14.4915C16.7048 14.4922 16.7193 14.4937 16.7335 14.4959C16.7508 14.4979 16.7679 14.5011 16.7848 14.5053C16.7905 14.5067 16.7957 14.5088 16.8012 14.5104C17.0012 14.5835 17.1334 14.7748 17.1307 14.9877V15.8674C17.1304 16.2333 17.2755 16.5845 17.5342 16.8434C17.5797 16.8878 17.6283 16.9291 17.6795 16.967C17.6944 16.9778 17.7098 16.9874 17.7255 16.9977C17.7641 17.0241 17.8031 17.0485 17.8437 17.0707C17.8598 17.0794 17.8758 17.088 17.8921 17.0959C17.9384 17.1189 17.9858 17.1393 18.0343 17.157C18.0439 17.1605 18.0533 17.1649 18.0632 17.1681C18.1892 17.2111 18.3206 17.2358 18.4536 17.2416H18.4551C18.5191 17.2441 18.5833 17.2422 18.6471 17.2358L18.6701 17.2333C18.693 17.2308 18.716 17.2298 18.739 17.226V19.5411H7.25759Z"
                  fill="#221F1F"
                />
                <path
                  d="M12.9957 9.20846C13.6295 9.20768 14.1431 8.69408 14.1437 8.06042C14.1437 7.50927 13.3449 6.32479 13.1847 6.09305C13.1395 6.03442 13.0698 6 12.9957 6C12.9217 6 12.8519 6.03442 12.8068 6.09305C12.6465 6.32479 11.8477 7.50927 11.8477 8.06042C11.8484 8.69408 12.362 9.20768 12.9957 9.20846ZM12.9957 6.6386C13.3261 7.15499 13.6845 7.80962 13.6845 8.06042C13.6845 8.44082 13.3762 8.74924 12.9957 8.74924C12.6153 8.74924 12.3069 8.44082 12.3069 8.06042C12.3069 7.80962 12.6653 7.15499 12.9957 6.6386Z"
                  fill="#00AAE9"
                />
                <path
                  d="M16.9019 9.66744C17.5357 9.66666 18.0493 9.15307 18.05 8.5194C18.05 7.96825 17.2512 6.78378 17.091 6.55204C17.0458 6.4934 16.9761 6.45898 16.9019 6.45898C16.828 6.45898 16.7581 6.4934 16.713 6.55204C16.5527 6.78378 15.7539 7.96825 15.7539 8.5194C15.7547 9.15307 16.2683 9.66666 16.9019 9.66744ZM16.9019 7.09758C17.2323 7.61398 17.5908 8.26861 17.5908 8.5194C17.5908 8.8998 17.2825 9.20823 16.9019 9.20823C16.5215 9.20823 16.2131 8.8998 16.2131 8.5194C16.2131 8.26861 16.5715 7.61398 16.9019 7.09758Z"
                  fill="#00AAE9"
                />
                <path
                  d="M9.09335 9.66744C9.72713 9.66666 10.2407 9.15307 10.2414 8.5194C10.2414 7.96825 9.44259 6.78378 9.28238 6.55204C9.23719 6.4934 9.16746 6.45898 9.09335 6.45898C9.01936 6.45898 8.94951 6.4934 8.90444 6.55204C8.74412 6.78378 7.94531 7.96825 7.94531 8.5194C7.9461 9.15307 8.45969 9.66666 9.09335 9.66744ZM9.09335 7.09758C9.42375 7.61398 9.78218 8.26861 9.78218 8.5194C9.78218 8.8998 9.47387 9.20823 9.09335 9.20823C8.71295 9.20823 8.40453 8.8998 8.40453 8.5194C8.40453 8.26861 8.76296 7.61398 9.09335 7.09758Z"
                  fill="#00AAE9"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_3394_2429"
                  x1="13"
                  y1="0"
                  x2="13"
                  y2="26"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#F5F6FD" />
                  <stop offset="1" stop-color="#F1F8FF" />
                </linearGradient>
                <clipPath id="clip0_3394_2429">
                  <rect
                    width="14"
                    height="14"
                    fill="white"
                    transform="translate(6 6)"
                  />
                </clipPath>
              </defs>
            </svg>
            <span>{{ orphan.dob | dobToAge }}</span>
          </p>
          <p class="orphanInfo">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="13"
                cy="13"
                r="13"
                fill="url(#paint0_linear_3394_2438)"
              />
              <g clip-path="url(#clip0_3394_2438)">
                <path
                  d="M13 6C9.14027 6 6 9.14027 6 13C6 16.8597 9.14027 20 13 20C16.8597 20 20 16.8597 20 13C20 9.14027 16.8597 6 13 6ZM13 19.125C9.62262 19.125 6.875 16.3774 6.875 13C6.875 9.62262 9.62262 6.875 13 6.875C16.3774 6.875 19.125 9.62262 19.125 13C19.125 16.3774 16.3774 19.125 13 19.125Z"
                  fill="#221F1F"
                  stroke="#F4F6FD"
                  stroke-width="0.3"
                />
                <path
                  d="M13.4375 8.625H12.5625V13.1811L15.3157 15.9343L15.9343 15.3157L13.4375 12.8188V8.625Z"
                  fill="#00AAE9"
                  stroke="#F4F6FD"
                  stroke-width="0.2"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_3394_2438"
                  x1="13"
                  y1="0"
                  x2="13"
                  y2="26"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#F5F6FD" />
                  <stop offset="1" stop-color="#F1F8FF" />
                </linearGradient>
                <clipPath id="clip0_3394_2438">
                  <rect
                    width="14"
                    height="14"
                    fill="white"
                    transform="translate(6 6)"
                  />
                </clipPath>
              </defs>
            </svg>

            <span>{{
              lastSponsoredDate(orphan.sponserd_date, orphan.is_sponsered)
            }}</span>
          </p>
          <p class="orphanInfo">{{ orphan.one_line_intro }}</p>
        </div>
      </ng-container>
    </div>
    <div class="videoWrapper" [ngClass]="loading ? 'skeleton' : ''">
      <iframe
        *ngIf="orphan"
        width="420"
        height="345"
        [src]="orphanVideoUrl"
        frameborder="0"
      ></iframe>
    </div>

    <div class="orphanCardWrapper">
      <div class="outer-card story-card">
        <div class="outer-card-head">
          <h3>{{ orphan.name }}'s Story</h3>
          <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5093_192)">
              <path
                class="forMinus"
                d="M7 14.5C6.8187 14.5 6.64482 14.428 6.51663 14.2998C6.38843 14.1716 6.31641 13.9977 6.31641 13.8164V1.18359C6.31641 1.00229 6.38843 0.828419 6.51663 0.70022C6.64482 0.572021 6.8187 0.5 7 0.5C7.1813 0.5 7.35518 0.572021 7.48337 0.70022C7.61157 0.828419 7.68359 1.00229 7.68359 1.18359V13.8164C7.68359 13.9977 7.61157 14.1716 7.48337 14.2998C7.35518 14.428 7.1813 14.5 7 14.5Z"
                fill="#221F1F"
              />
              <path
                d="M13.3164 8.18359H0.683594C0.502293 8.18359 0.328419 8.11157 0.20022 7.98337C0.0720213 7.85518 0 7.6813 0 7.5C0 7.3187 0.0720213 7.14482 0.20022 7.01663C0.328419 6.88843 0.502293 6.81641 0.683594 6.81641H13.3164C13.4977 6.81641 13.6716 6.88843 13.7998 7.01663C13.928 7.14482 14 7.3187 14 7.5C14 7.6813 13.928 7.85518 13.7998 7.98337C13.6716 8.11157 13.4977 8.18359 13.3164 8.18359Z"
                fill="#221F1F"
              />
            </g>
            <defs>
              <clipPath id="clip0_5093_192">
                <rect
                  width="14"
                  height="14"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="outer-card-body" style="display: none">
          <div class="orphanParas">
            <div class="parasWrapper">
              <p *ngFor="let para of orphanStory">{{ para }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="outer-card show">
        <div class="outer-card-head">
          <h3>Frequently Asked Questions</h3>
          <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5093_192)">
              <path
                class="forMinus"
                d="M7 14.5C6.8187 14.5 6.64482 14.428 6.51663 14.2998C6.38843 14.1716 6.31641 13.9977 6.31641 13.8164V1.18359C6.31641 1.00229 6.38843 0.828419 6.51663 0.70022C6.64482 0.572021 6.8187 0.5 7 0.5C7.1813 0.5 7.35518 0.572021 7.48337 0.70022C7.61157 0.828419 7.68359 1.00229 7.68359 1.18359V13.8164C7.68359 13.9977 7.61157 14.1716 7.48337 14.2998C7.35518 14.428 7.1813 14.5 7 14.5Z"
                fill="#221F1F"
              />
              <path
                d="M13.3164 8.18359H0.683594C0.502293 8.18359 0.328419 8.11157 0.20022 7.98337C0.0720213 7.85518 0 7.6813 0 7.5C0 7.3187 0.0720213 7.14482 0.20022 7.01663C0.328419 6.88843 0.502293 6.81641 0.683594 6.81641H13.3164C13.4977 6.81641 13.6716 6.88843 13.7998 7.01663C13.928 7.14482 14 7.3187 14 7.5C14 7.6813 13.928 7.85518 13.7998 7.98337C13.6716 8.11157 13.4977 8.18359 13.3164 8.18359Z"
                fill="#221F1F"
              />
            </g>
            <defs>
              <clipPath id="clip0_5093_192">
                <rect
                  width="14"
                  height="14"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="outer-card-body">
          <app-sponsor-faqs *ngIf="orphan && isMobile"></app-sponsor-faqs>
        </div>
      </div>
      <div class="outer-card moreChildren-card show">
        <div class="outer-card-head">
          <h3>View More Children</h3>
          <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5093_192)">
              <path
                class="forMinus"
                d="M7 14.5C6.8187 14.5 6.64482 14.428 6.51663 14.2998C6.38843 14.1716 6.31641 13.9977 6.31641 13.8164V1.18359C6.31641 1.00229 6.38843 0.828419 6.51663 0.70022C6.64482 0.572021 6.8187 0.5 7 0.5C7.1813 0.5 7.35518 0.572021 7.48337 0.70022C7.61157 0.828419 7.68359 1.00229 7.68359 1.18359V13.8164C7.68359 13.9977 7.61157 14.1716 7.48337 14.2998C7.35518 14.428 7.1813 14.5 7 14.5Z"
                fill="#221F1F"
              />
              <path
                d="M13.3164 8.18359H0.683594C0.502293 8.18359 0.328419 8.11157 0.20022 7.98337C0.0720213 7.85518 0 7.6813 0 7.5C0 7.3187 0.0720213 7.14482 0.20022 7.01663C0.328419 6.88843 0.502293 6.81641 0.683594 6.81641H13.3164C13.4977 6.81641 13.6716 6.88843 13.7998 7.01663C13.928 7.14482 14 7.3187 14 7.5C14 7.6813 13.928 7.85518 13.7998 7.98337C13.6716 8.11157 13.4977 8.18359 13.3164 8.18359Z"
                fill="#221F1F"
              />
            </g>
            <defs>
              <clipPath id="clip0_5093_192">
                <rect
                  width="14"
                  height="14"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="outer-card-body">
          <app-more-children
            *ngIf="moreChildren && isMobile"
            [moreChildren]="moreChildren"
            [appClass]="''"
          >
          </app-more-children>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="mobOnly fixedSponsorWrapper" *ngIf="orphan">
  <a
    href="javascript:;"
    *ngIf="!disabledBtn"
    class="sponsorMainBtn"
    (click)="saveOrphan(orphan, moreChildren)"
  >
    Sponsor {{ orphan.name }}
  </a>
  <a href="javascript:;" *ngIf="disabledBtn" class="sponsorMainBtn loaderBlue">
    <img
      class="loadingImg"
      src="/assets/new-images/pshLoaderWhite.webp"
      alt="loading"
    />
  </a>
  <!-- <div class="loader" *ngIf="disabledBtn">
    <img class="loadingImg" src="/assets/new-images/pshLoader.webp" alt="loading">
  </div> -->
  <a href="javascript:;" class="copyMainBtn" (click)="copyUrl()">
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0236 10.6942C12.8396 10.6942 12.6556 10.6242 12.5154 10.4836C11.3945 9.36275 9.57072 9.36239 8.44947 10.4836C8.16916 10.7643 7.71347 10.7643 7.43316 10.4836C7.15249 10.203 7.15249 9.748 7.43316 9.46733C9.11468 7.78545 11.8506 7.78581 13.5318 9.46733C13.8124 9.748 13.8124 10.203 13.5318 10.4836C13.3916 10.6242 13.2072 10.6942 13.0236 10.6942Z"
        fill="#A6BCC8"
        stroke="#A6BCC8"
        stroke-width="0.5"
      />
      <path
        d="M12.5176 14.7945C11.4133 14.7945 10.3089 14.374 9.46832 13.5335C9.18764 13.2528 9.18764 12.7978 9.46832 12.5171C9.74863 12.2365 10.2043 12.2365 10.4846 12.5171C11.6055 13.638 13.4293 13.6384 14.5506 12.5171C14.8309 12.2365 15.2866 12.2365 15.5669 12.5171C15.8476 12.7978 15.8476 13.2528 15.5669 13.5335C14.726 14.374 13.6216 14.7945 12.5176 14.7945Z"
        fill="#A6BCC8"
        stroke="#A6BCC8"
        stroke-width="0.5"
      />
      <path
        d="M15.0585 13.7434C14.8745 13.7434 14.6905 13.6733 14.5503 13.5328C14.2697 13.2521 14.2697 12.7971 14.5503 12.5165L18.5653 8.50152C18.8456 8.22085 19.3013 8.22085 19.5816 8.50152C19.8623 8.78219 19.8623 9.23716 19.5816 9.51783L15.5667 13.5328C15.4265 13.6733 15.2425 13.7434 15.0585 13.7434Z"
        fill="#A6BCC8"
        stroke="#A6BCC8"
        stroke-width="0.5"
      />
      <path
        d="M9.01163 19.7911C8.82763 19.7911 8.64363 19.721 8.50347 19.5805C8.2228 19.2998 8.2228 18.8448 8.50347 18.5642L10.7478 16.3199C11.0281 16.0392 11.4838 16.0392 11.7641 16.3199C12.0448 16.6006 12.0448 17.0555 11.7641 17.3362L9.51979 19.5805C9.37963 19.721 9.19563 19.7911 9.01163 19.7911Z"
        fill="#A6BCC8"
        stroke="#A6BCC8"
        stroke-width="0.5"
      />
      <path
        d="M3.9296 14.7088C3.7456 14.7088 3.5616 14.6387 3.42144 14.4982C3.14077 14.2176 3.14077 13.7626 3.42144 13.4819L7.43638 9.46734C7.71705 9.18667 8.17238 9.18667 8.45269 9.46734C8.73336 9.74801 8.73336 10.203 8.45269 10.4837L4.43775 14.4982C4.29724 14.6384 4.11324 14.7088 3.9296 14.7088Z"
        fill="#A6BCC8"
        stroke="#A6BCC8"
        stroke-width="0.5"
      />
      <path
        d="M11.746 6.89105C11.562 6.89105 11.3784 6.82097 11.2378 6.68082C10.9572 6.40014 10.9572 5.94518 11.2378 5.66414L13.4821 3.41949C13.7628 3.13882 14.2178 3.13882 14.4988 3.41949C14.7795 3.70016 14.7795 4.15513 14.4988 4.43616L12.2545 6.68082C12.114 6.82061 11.9296 6.89105 11.746 6.89105Z"
        fill="#A6BCC8"
        stroke="#A6BCC8"
        stroke-width="0.5"
      />
      <path
        d="M6.46883 20.8208C5.35728 20.8208 4.24573 20.4075 3.41953 19.5809C1.76641 17.9278 1.76641 15.1351 3.41953 13.482C3.69984 13.2013 4.15553 13.2013 4.43584 13.482C4.71652 13.7627 4.71652 14.2176 4.43584 14.4983C3.334 15.6001 3.334 17.4624 4.43584 18.5643C5.53769 19.6661 7.39997 19.6661 8.50181 18.5643C8.78212 18.2836 9.23781 18.2836 9.51813 18.5643C9.7988 18.8449 9.7988 19.2999 9.51813 19.5806C8.69192 20.4075 7.58038 20.8208 6.46883 20.8208Z"
        fill="#A6BCC8"
        stroke="#A6BCC8"
        stroke-width="0.5"
      />
      <path
        d="M19.0744 9.72872C18.8904 9.72872 18.7064 9.65864 18.5662 9.51812C18.2856 9.23745 18.2856 8.78248 18.5662 8.50181C19.6681 7.39997 19.6681 5.53769 18.5662 4.43584C17.4644 3.334 15.6021 3.334 14.5003 4.43584C14.2199 4.71652 13.7643 4.71652 13.4839 4.43584C13.2033 4.15517 13.2033 3.7002 13.4839 3.41953C15.1371 1.76641 17.9298 1.76641 19.5829 3.41953C21.236 5.07266 21.236 7.86536 19.5829 9.51848C19.4424 9.65864 19.2584 9.72872 19.0744 9.72872Z"
        fill="#A6BCC8"
        stroke="#A6BCC8"
        stroke-width="0.5"
      />
    </svg>
    <p class="copyToolTip">Copy Link</p>
  </a>
</section>
